import { theme } from '@zappyrent/hundop';
import { Loader2, Check, X } from 'lucide-react';

const BookingStageIcon = ({
  isRejected,
  isAccepted,
  isPending,
  isHolding,
}: {
  isRejected: boolean;
  isAccepted: boolean;
  isPending: boolean;
  isHolding?: boolean;
}) => {
  switch (true) {
    case isPending:
      return (
        <Loader2
          size={12}
          color={
            isHolding ? theme.colors.cross.arancin : theme.colors.cross.grayson
          }
        />
      );
    case isAccepted:
      return <Check size={12} color={theme.colors.cross.greenMint} />;
    case isRejected:
      return <X size={12} color={theme.colors.cross.red} />;
    default:
      return null;
  }
};

export default BookingStageIcon;
